// src/pages/CaseStudies.jsx
import React from "react";
import Footer from "../components/Footer";  // Import Footer

const caseStudies = [
  {
    title: "Rapidly finding new photocatalysts for carbon-carbon bond formation",
    partner: "AstraZeneca",
    year: 2025,
    link: "#",
  },
  {
    title: "Anti-Kasha Rulebreakers: The Search for Dual Emission",
    partner: "University of Liverpool",
    year: 2025,
    link: "#",
  },
  {
    title: "Going beyond fullerene for new organic solar cells",
    partner: "University of Oxford",
    year: 2024,
    link: "#",
  },
  {
    title: "Breaking Hund’s Rule: Next-Gen OLEDs",
    partner: "UNISI",
    year: 2023,
    link: "#",
  },
];

export default function CaseStudies() {
  return (
    <>
      <section className="min-h-screen py-20 px-6 sm:px-8 bg-[#1A1631] text-white">
        <div className="max-w-5xl mx-auto">
          <a
            href="/"
            className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
          >
            <span className="mr-2 text-lg">←</span> Back to main site
          </a>

          <h1 className="text-4xl md:text-5xl font-bold mb-8">
            <span className="bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
              Case Studies
            </span>
          </h1>

          <p className="text-lg text-slate-300 mb-12 max-w-2xl">
            Explore real-world examples of how DiaDEM<sup>™</sup> accelerates material
            discovery and transforms research workflows in both academia and industry.
          </p>

          <ul className="space-y-8">
            {caseStudies.map((study, idx) => (
              <li
                key={idx}
                className="p-6 border border-[#EF7C34]/20 bg-[#2A2444]/60 rounded-xl shadow hover:shadow-orange-500/20 transition-all flex justify-between items-start"
              >
                <div className="pr-4 flex-1">
                  <h2 className="text-xl font-semibold text-orange-300 mb-2">
                    {study.title}
                  </h2>
                  <p className="text-sm text-slate-400 italic mb-1">
                    {study.partner} — {study.year}
                  </p>
                  <p className="text-sm text-slate-300 mb-2">{study.summary}</p>
                  {study.link && (
                    <a
                      href={study.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#F89B3F] text-sm underline hover:text-[#EF7C34]"
                    >
                      {/* View Full Study ↗ */}
                    </a>
                  )}
                </div>

                {(idx >= 0 && idx <= 4) && (
                  <div className="bg-white rounded-md w-28 h-28 flex items-center justify-center shadow-md shrink-0">
                    <img
                      src={
                        idx === 0
                          ? "/AZ.png"
                          : idx === 1
                          ? "/ULIV.png"
                          : idx === 2
                          ? "/oxford.png"
                          : idx === 3
                          ? "/siena.jpg"
                          : "/cdt.png"
                      }
                      alt={`${study.partner} logo`}
                      className="object-contain w-full h-full p-2"
                    />
                  </div>
                )}
              </li>
            ))}
          </ul>

        </div>
      </section>

      {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
